import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import user from './user'
import { getField, updateField } from 'vuex-map-fields';
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    user,
  },
  strict: process.env.DEV,
  state: {
    controlValue: {
        showLayout: true,
        floatLayout: true,
        enableDownload: true,
        previewModal: true,
        paginateElementsByHeight: 11000,
        manualPagination: false,
        filename: 'Invoice',
        pdfQuality: 4,
        pdfFormat: 'a4',
        pdfOrientation: 'portrait',
        pdfContentWidth: '800px',
        minHeight:12,
        showZero: false,
    }
},
mutations: {
    updateField
},

getters: {
    getField
},
})
